import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ZoomInIcon, XIcon } from 'lucide-react';
import { useBackNavigation } from '../hooks/useBackNavigation';
export function Sketching() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const goBack = useBackNavigation('/art');
  const artworks = [{
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-11-18_21-49-29.jpg',
    year: '2025'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-11-18_21-49-15.jpg',
    year: '2025'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-09-24_11-35-11.jpg',
    year: '2025'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-11-18_21-49-44.jpg',
    year: '2025'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/IMG_20231215_003710_320%20(3).webp',
    year: '2024'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231010_003056%20(3).jpg',
    year: '2022'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013143.jpg',
    year: '2017'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013259%20(1).jpg',
    year: '2017'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013152.jpg',
    year: '2017'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013126.jpg',
    year: '2017'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_012923.jpg',
    year: '2016'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013250.jpg',
    year: '2016'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-2129">
      {/* Image Modal */}
      {selectedImage && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setSelectedImage(null)} data-id="element-2130">
          <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white hover:text-stone-400 transition-colors" data-id="element-2131">
            <XIcon className="w-8 h-8" data-id="element-2132" />
          </button>
          <motion.img initial={{
        scale: 0.9
      }} animate={{
        scale: 1
      }} src={selectedImage} alt="Enlarged view" className="max-w-full max-h-full object-contain" data-id="element-2133" />
        </motion.div>}
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-stone-200 sticky top-0 z-40" data-id="element-2134">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-2135">
          <button onClick={goBack} className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-2136">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-2137" />
            <span className="font-light" data-id="element-2138">Back</span>
          </button>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-2139">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-10 px-6 bg-gradient-to-br from-stone-50 via-stone-100/30 to-stone-50" data-id="element-2140">
        <div className="max-w-5xl mx-auto" data-id="element-2141">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-2142">
            <p className="text-stone-600 font-light tracking-wide uppercase mb-2" data-id="element-2143">
              Observational Drawing
            </p>
            <h1 className="text-4xl md:text-6xl font-light text-stone-900 mb-4" data-id="element-2144">
              Sketching
            </h1>
            <p className="text-xl text-stone-600 font-light" data-id="element-2145">
              Architectural, observational and imagination sketches
            </p>
          </motion.div>
        </div>
      </section>
      {/* Gallery Grid */}
      <section className="py-20 px-6 bg-white pt-[40px] pb-[40px]" data-id="element-2146">
        <div className="max-w-7xl mx-auto" data-id="element-2147">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2148">
            {artworks.map((artwork, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group" data-id="element-2149">
                <div className="relative overflow-hidden rounded-xl shadow-lg mb-4 aspect-square cursor-pointer" onClick={() => setSelectedImage(artwork.image)} data-id="element-2150">
                  <img src={artwork.image} alt={`Artwork ${index + 1}`} className="w-full h-full object-cover" data-id="element-2151" />
                  <div className="absolute inset-0 bg-stone-900/0 group-hover:bg-stone-900/10 transition-colors duration-300 flex items-center justify-center" data-id="element-2152">
                    <ZoomInIcon className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-2153" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-2154">
                  <p className="text-sm text-stone-600 font-light" data-id="element-2155">
                    {artwork.year}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}